import AffiliateService from '../services/affiliate.service'

export const affiliateModule = {
  namespaced: true,

  state: {
    affiliates: [],
    affiliateDetail: null,
    affiliate: null,
    criterias: null,
    invalidData: null
  },

  actions: {
    async search ({ commit }, criterias) {
      return AffiliateService.search(criterias).then(
        response => {
          const affiliates = response.data
          commit('searchSuccess', affiliates)
          return Promise.resolve(affiliates)
        },
        error => {
          commit('searchFailure')
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async detail ({ commit }, criterias) {
      return AffiliateService.detail(criterias).then(
        response => {
          const affiliateDetail = response.data
          commit('detailSuccess', affiliateDetail)
          return Promise.resolve(affiliateDetail)
        },
        error => {
          commit('detailFailure')
          return Promise.reject(error.response.data)
        }
      )
    },

    async activate ({ commit }, criterias) {
      return AffiliateService.activate(criterias).then(
        response => {
          const affiliateDetail = response.data
          commit('actionSuccess', affiliateDetail)
          return Promise.resolve(affiliateDetail)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async inactivate ({ commit }, criterias) {
      return AffiliateService.inactivate(criterias).then(
        response => {
          const affiliateDetail = response.data
          commit('actionSuccess', affiliateDetail)
          return Promise.resolve(affiliateDetail)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async addProvider ({ commit }, criterias) {
      return AffiliateService.addProvider(criterias).then(
        response => {
          const responseData = response.data
          commit('operationSuccess', responseData)
          return Promise.resolve(responseData)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async updateProvider ({ commit }, criterias) {
      return AffiliateService.updateProvider(criterias).then(
        response => {
          const responseData = response.data
          commit('operationSuccess', responseData)
          return Promise.resolve(responseData)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async deleteProvider ({ commit }, criterias) {
      return AffiliateService.deleteProvider(criterias).then(
        response => {
          const responseData = response.data
          commit('operationSuccess', responseData)
          return Promise.resolve(responseData)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async addMerchant ({ commit }, criterias) {
      return AffiliateService.addMerchant(criterias).then(
        response => {
          const responseData = response.data
          commit('operationSuccess', responseData)
          return Promise.resolve(responseData)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async updateMerchant ({ commit }, criterias) {
      return AffiliateService.updateMerchant(criterias).then(
        response => {
          const responseData = response.data
          commit('operationSuccess', responseData)
          return Promise.resolve(responseData)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async deleteMerchant ({ commit }, criterias) {
      return AffiliateService.deleteMerchant(criterias).then(
        response => {
          const responseData = response.data
          commit('operationSuccess', responseData)
          return Promise.resolve(responseData)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async reset ({ commit }) {
      commit('listReset')
    },

    async resetDetail ({ commit }) {
      commit('detailReset')
    },

    async setAffiliate ({ commit }, affiliate) {
      commit('affiliateSuccess', affiliate)
    },

    async setCriterias ({ commit }, criterias) {
      commit('setCriterias', criterias)
    },

    async resetCriterias ({ commit }) {
      commit('resetCriterias')
    },

    async invalidData ({ commit }, error) {
      commit('invalidData', error)
    },

    async resetInvalidData ({ commit }) {
      commit('invalidData', null)
    }
  },

  mutations: {
    detailSuccess (state, affiliateDetail) {
      state.affiliateDetail = affiliateDetail
    },
    detailFailure (state) {
      state.affiliateDetail = null
    },
    listReset (state) {
      state.affiliates = []
    },
    searchSuccess (state, affiliates) {
      state.affiliates = affiliates
    },
    searchFailure (state) {
      state.affiliates = []
    },
    actionSuccess (state, affiliateDetail) {
      state.affiliateDetail = affiliateDetail
    },
    detailReset (state) {
      state.affiliateDetail = null
    },
    operationSuccess (state, affiliateDetail) {
      state.affiliateDetail = affiliateDetail
    },
    affiliateSuccess (state, affiliate) {
      state.affiliate = affiliate
    },
    setCriterias (state, criterias) {
      state.criterias = criterias
    },
    resetCriterias (state) {
      state.criterias = null
    },
    invalidData (state, error) {
      state.invalidData = error
    }
  }
}
